import { render, staticRenderFns } from "./ShiXinLabelV2Dialog.vue?vue&type=template&id=13598146&scoped=true"
import script from "./ShiXinLabelV2Dialog.vue?vue&type=script&lang=js"
export * from "./ShiXinLabelV2Dialog.vue?vue&type=script&lang=js"
import style0 from "./ShiXinLabelV2Dialog.vue?vue&type=style&index=0&id=13598146&prod&scoped=true&lang=css"
import style1 from "./ShiXinLabelV2Dialog.vue?vue&type=style&index=1&id=13598146&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13598146",
  null
  
)

export default component.exports